<fui-edit-fascia [disabled]="disabled" (focussed$)="focus()">
    <fui-fixtures>
        <fui-fixture>
            <fui-radio-dom [disabled]="disabled" [focussed]="focussed" [hovered]="hovered" [valued]="valued">
                <input (blur)="onBlur($event)" [disabled]="disabled" (focus)="onFocus($event)" [id]="id()" #input [name]="name"
                       [(ngModel)]="value" [tabindex]="tabindex" type="radio" [value]="equivalent">
            </fui-radio-dom>
        </fui-fixture>
        <fui-fixture>
            <fui-checkbox-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                                [title]="label" [valued]="valued"></fui-checkbox-label>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
